<template>
    <div>
        <refund-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :paginationData="filterSet.page"></refund-filter-link>
        <refund-list-link :listLayout="listLayout" :paginationData="filterSet.page" :refundData="List"></refund-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :listLength="List.length" :type="refundType"></pagination-link>
    </div>
</template>

<script>
    import RefundFilterLink from "@/components/refund/RefundFilterLink";
    import RefundListLink from "@/components/refund/RefundListLink";
    import PaginationLink from "@/components/refund/PaginationLink";
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import alertMixins from "@/mixins/alertMixins";
    import refundUtil from "@/components/refund/refundUtil";

    const {filterConfig} = refundUtil;

    export default {
        name: "RefundListComponent",
        mixins: [filterMixins,listMixins,alertMixins,refundUtil],
        components: {RefundFilterLink,RefundListLink,PaginationLink},
        provide() {
            return {
                setPage: this.setPage,
                setFilter: this.setFilter,
                refundListSetData: this.setData,
            }
        },
        inject: ['changeLoading'],
        props: {
            refundType: {default: ''},

        },
        data() {
            return {
                listLayout: '',
                filterLayout: '',
                paginationLayout: '',

                getFunc: '',
                listApiParamSet: {},
                pageRow: 10,


                /*필터 classname*/

            }
        },
        created() {
            this.setFilterConfig(filterConfig)
            this.setParserType('url', this.$route.fullPath);
            this.initConfig();
        },
        mounted() {
            this.getList(true);

        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
        },
        methods: {
            setData(type, value) {
                this[type] = value;
            },
            initConfig() {
                let config = this.returnRefundConfig(this.refundType)
                this.listLayout= config.listLayout;
                this.filterLayout = config.filterLayout;
                this.paginationLayout = config.paginationLayout;
                this.getFunc = config.getFunc;
                this.listApiParamSet = config.listApiParamSet;

                let listOptions = {
                    url : this.$api.$refund[this.getFunc],
                    defaultParams : this.listApiParamSet
                }
                this.initList('api', listOptions);
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>